import { Footer } from "./features/footer/Footer"
import { Home } from "./features/home/Home"
import { Header } from "./features/header/Header"
import { Toaster } from "sonner"
import { Route, Routes } from "react-router-dom"
import { User } from "./features/user/User"
import { Leaderboard } from "./features/leaderboard/Leaderboard"
import { AnimatedBackground } from "./features/background/AnimatedBackground"
import DesktopOnlyGate from "./components/DesktopOnlyGate"
// import { Background } from './features/background/Background'

export const App = () => (
  <div className="flex flex-col min-h-screen overflow-hidden font-mono">
    {/* <Background></Background> */}
    <DesktopOnlyGate minWidth={1024} allowCoarsePointer={false}>
      <AnimatedBackground />
      <Header></Header>
      <Routes>
        <Route path="/" element={<Home />} />
        <Route path="/leaderboards" element={<Leaderboard />} />
        <Route path="/user/:id" element={<User />} />
        <Route path="/user" element={<User />} />
        <Route path="*" element={<div className="flex flex-1 justify-center items-center text-9xl">404</div>} />
      </Routes>
      <Footer></Footer>
      <Toaster />
    </DesktopOnlyGate>
  </div>
)
